import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { EventLogs } from 'src/app/models/eventLog.model';
import { Plant } from 'src/app/models/plant.model';
import { Train } from 'src/app/models/train.model';
import { EventlogsService } from 'src/app/services/eventlogs/eventlogs.service';
import { PlantsService } from 'src/app/services/plants/plants.service';
import { TrainService } from 'src/app/services/trains/trains.service';
import { EventLogStateService } from '../../event-log-state.service';
import { Observable } from 'rxjs/internal/Observable';
 
@Component({
  selector: 'app-list-eventlogs',
  templateUrl: './list-eventlogs.component.html',
  styleUrls: ['./list-eventlogs.component.scss'],
})
export class ListEventlogsComponent {
  constructor(
    private router: Router,
    private trainService: TrainService,
    private plantService: PlantsService,
    private eventlogService: EventlogsService,
    private stateService: EventLogStateService
  ) {}
 
  dtoptions: DataTables.Settings = {};
  plants: Plant[] = [];
  trains: Train[] = [];
  selectedPlantId: string = '';
selectedTrainId: string = '';
  eventlogs: EventLogs[] = [];
  SelectedId: string;
  plantDetails: Plant = new Plant();
 
  trainDetails: Train = new Train();
 
  loggedInUserRole:string;
  loggedinUserId:string;
  plantAndUserId:string;

  selectedTrainIdFromBreadcrumbs: number;
  selectedPlantIdFromBreadcrumbs: number;
  trainId$: Observable<any[]>;
  plantId$: Observable<any[]>;

  getSelectedId(e) {
   
    this.SelectedId = e.target.value;
  this.selectedPlantId = this.SelectedId;
 
 
    if(this.loggedInUserRole =='Standard User')
      {
    this.plantAndUserId = this.SelectedId + 'Z' + this.loggedinUserId;
    this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)
     
      .subscribe(
        (response: Train[]) => {
          this.trains = response;
        },
        (error: any) => {
          console.log('error list');
        }
      );
  }
  else
  {
    this.trainService.getTrainByPlantId(this.SelectedId).subscribe(
      (response: Train[]) => {
        this.trains = response;
      },
 
      (error: any) => {
        console.log('error list');
      }
    );
  }
    this.plantService.getPlant(this.SelectedId).subscribe({
      next: (response) => {
        this.plantDetails = response;
         this.stateService.setFilter(this.selectedPlantId, this.selectedTrainId || '');  // ← ADD THIS LINE
        console.log(this.plantDetails);
      },
    });
  }
 
  getSelectedTrainId(e) {
    this.SelectedId = e.target.value;
     this.selectedTrainId = this.SelectedId;
    this.eventlogs.length = 0;
    this.eventlogService
      .getEventLogsListByTrainId(this.SelectedId)
      .subscribe((response: EventLogs[]) => {
        this.eventlogs = response;
        console.log(this.eventlogs);
      });
 
      this.trainService.getTrainById(this.SelectedId).subscribe({
        next: (response) => {
          this.trainDetails = response;
          this.stateService.setFilter(this.selectedPlantId, this.selectedTrainId);
          console.log(this.trainDetails);
        },
      });
  }
 
  navigate(TId){
    console.log(TId);
    var id = btoa(TId.toString())
    this.router.navigate(['/component/eventlogs/edit/' + id]);
  }
 
  ngOnInit(): void {
    this.dtoptions = {
      pagingType: 'full_numbers',
      order: [[0, 'desc']],
    };
 
    let loggedInuserRole = JSON.parse(atob(sessionStorage.getItem('currentUser')!));
    if(loggedInuserRole.role =='Standard User')
    {
      this.loggedInUserRole = loggedInuserRole.role;
      this.loggedinUserId = loggedInuserRole.userId;
      this.plantService.getPlantsByUserId(loggedInuserRole.userId)
      .subscribe({
        next: (plants)=>{
          this.plants = plants;
        },
      })
     
    }
    else
    {
    this.plantService.getAllPlant().subscribe({
      next: (plants) => {
        this.plants = plants;
        this.restoreSelection();
      },
      error: (response) => {
        console.log(response);
      },
    });
  }
     //load data using plantId from breadcrumbs
    this.eventlogService.plantId$.subscribe(plantId => {
      if (plantId) {
          this.getSelectedId({ target: { value: plantId } });
      }
    });

    //load data using trainid from breadcrumbs
    this.eventlogService.trainId$.subscribe(trainId => {
      if (trainId) {
          this.getSelectedTrainId({ target: { value: trainId } });
      }
    });
}
 
clearFilters(): void {
  this.selectedPlantId = '';
  this.selectedTrainId = '';
  this.SelectedId = '';
  this.trains = [];
  this.eventlogs = [];
  this.plantDetails = new Plant();
  this.trainDetails = new Train();
  this.stateService.clearFilter();
  console.log('Filters cleared');
}
 
 
restoreSelection(): void {
  const saved = this.stateService.getFilter();
 
  if (saved.plantId) {
    this.selectedPlantId = saved.plantId;
   
    // Load plant details FIRST
    this.plantService.getPlant(saved.plantId).subscribe({
      next: (response) => {
        this.plantDetails = response;
        console.log('Plant details restored:', this.plantDetails);
      }
    });
   
    // Load trains
    if (this.loggedInUserRole == 'Standard User') {
      this.plantAndUserId = saved.plantId + 'Z' + this.loggedinUserId;
      this.trainService.GetAccessibleTrainListByPlantId(this.plantAndUserId)
        .subscribe((response: Train[]) => {
          this.trains = response;
         
          if (saved.trainId) {
            this.selectedTrainId = saved.trainId;
           
            // Load train details
            this.trainService.getTrainById(saved.trainId).subscribe({
              next: (response) => {
                this.trainDetails = response;
                console.log('Train details restored:', this.trainDetails);
              }
            });
           
            // Load event logs
            this.eventlogService.getEventLogsListByTrainId(saved.trainId)
              .subscribe((response: EventLogs[]) => {
                this.eventlogs = response;
                console.log('Event logs restored:', this.eventlogs.length);
              });
          }
        });
    } else {
      this.trainService.getTrainByPlantId(saved.plantId)
        .subscribe((response: Train[]) => {
          this.trains = response;
         
          if (saved.trainId) {
            this.selectedTrainId = saved.trainId;
           
            // Load train details
            this.trainService.getTrainById(saved.trainId).subscribe({
              next: (response) => {
                this.trainDetails = response;
                console.log('Train details restored:', this.trainDetails);
              }
            });
           
            // Load event logs
            this.eventlogService.getEventLogsListByTrainId(saved.trainId)
              .subscribe((response: EventLogs[]) => {
                this.eventlogs = response;
                console.log('Event logs restored:', this.eventlogs.length);
              });
          }
        });
    }
  }
}
 
}
 
